import { useTranslation } from 'react-i18next';

import { ProductType } from '../types';

export const useReadableProductName = (product?: ProductType | null | undefined): string => {
  const { t } = useTranslation('common');

  switch (product) {
    case ProductType.Analytics:
      return t('analytics-product');
    case ProductType.Feedback:
      return t('feedback-product');
    default:
      return '';
  }
};
